import {
  CUISINES_REQUEST,
  CUISINES_SUCCESS,
  CUISINES_FAILURE,
  CUISINE_REQUEST,
  CUISINE_SUCCESS,
  CUISINE_FAILURE,
  CUISINE_RESTAURANTS_REQUEST,
  CUISINE_RESTAURANTS_SUCCESS,
  CUISINE_RESTAURANTS_FAILURE,
} from '../../actions/types';
import { isAddressInCity, createRestaurantsForCuisine } from './factories';

const initialState = {
  loading: false,
};

export default function cuisineReducer(state = initialState, action = {}) {
  switch (action.type) {
    case CUISINES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CUISINES_SUCCESS:
      return {
        ...state,
        loading: false,
        all: action.payload.data.cuisines,
      };
    case CUISINES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CUISINE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CUISINE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CUISINE_SUCCESS: {
      const cuisine = action.payload.data.cuisine || {};
      const {
        restaurant_reviews: restaurantReviews,
        recommended_cuisines: recommendedCuisines,
        alternate_locale_cuisines: alternateLocales,
        neighborhoods,
        cities,
        error,
      } = action.payload.data;

      const {
        cuisineName,
        cuisineSlug,
        cityName,
        title,
        description,
        image,
        pageTitle,
        metaDescription,
      } = cuisine;

      return {
        ...state,
        error,
        loading: false,
        cuisine: cuisineName,
        slug: cuisineSlug,
        city: cityName,
        title,
        description,
        image,
        pageTitle,
        metaDescription,
        restaurantReviews: restaurantReviews || [],
        recommendedCuisines: recommendedCuisines || [],
        alternateLocales: (alternateLocales || []).map(
          ({ locale, cuisineSlug: alternateLocaleCuisine, citySlug: alternateLocaleCity }) => ({
            locale,
            cuisine: alternateLocaleCuisine,
            city: alternateLocaleCity,
          }),
        ),
        neighborhoods: neighborhoods || [],
        cities: cities || [],
      };
    }
    case CUISINE_RESTAURANTS_REQUEST: {
      const { restaurants } = state;
      const prevPending = (restaurants && restaurants.pending) || 0;

      return {
        ...state,
        restaurants: {
          loading: true,
          pending: prevPending + 1,
        },
      };
    }
    case CUISINE_RESTAURANTS_FAILURE: {
      const stillPending = state.restaurants.pending - 1;

      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          loading: stillPending !== 0,
          pending: stillPending,
        },
      };
    }
    case CUISINE_RESTAURANTS_SUCCESS: {
      const { city, cuisine, address, data, meta = {} } = action.payload;
      const prevRestaurants = state.restaurants.data ? state.restaurants.data : [];
      const stillPending = state.restaurants.pending - 1;

      return {
        ...state,
        restaurants: {
          ...state.restaurants,
          loading: stillPending !== 0,
          pending: stillPending,
          data: isAddressInCity(address, city)
            ? prevRestaurants.concat([
                {
                  address: {
                    ...address,
                    neighborhood: meta.neighborhood_name,
                  },
                  restaurants: createRestaurantsForCuisine(data, cuisine),
                },
              ])
            : prevRestaurants,
        },
      };
    }
    default:
      return state;
  }
}
